<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-divider>单位信息</van-divider>
        <van-cell-group>
            <van-cell title="赛季" :value="pageData.sjname" />
            <van-cell title="赛区" :value="pageData.sqname" />
            <van-cell title="单位" :value="pageData.danwei" />
            <van-cell title="队伍名称" :value="pageData.mingcheng" />
            <van-cell title="食宿服务" :value="pageData.need_shisu==1?'是':'否'" />
        </van-cell-group>

        <div v-if="pageData.need_shisu==1">
            <van-divider>数量信息</van-divider>
            <van-cell-group v-if="pageData.room_list">
                <van-cell title="总人数" :label="pageData.m_member_count+'男'+pageData.f_member_count+'女'" :value="pageData.total_member_count" />
                <van-cell title="房间数"  >
                    总计{{pageData.room_list.length}}间
                    <div v-for="(count,type) in pageData.room_types">{{type}} x {{count}}</div>
                </van-cell>
                <van-cell title="特殊要求" :value="pageData.shisudes" />
            </van-cell-group>
            <div v-else class="sub-title">用户信息未提交</div>


            <van-divider>酒店信息</van-divider>
            <van-cell-group v-if="pageData.hotel">
                <van-cell title="酒店名称" :value="pageData.hotel.name" />
                <!--<van-cell title="联系人" :value="pageData.hotel.contact_name" />-->
                <!--<van-cell title="联系电话" :value="pageData.hotel.contact_phone" />-->
                <van-cell title="地址" :value="pageData.hotel.address" />
            </van-cell-group>
            <div  class="sub-title" style="color: #999 ; text-align: center">等待更新</div>


            <van-divider>交通信息</van-divider>
            <van-cell-group v-if="pageData.bus_list.length>0">
                <van-cell v-for="(bus,index) in pageData.bus_list" :title="bus.name" >
                    <!--<div> 车牌:{{bus.card}} </div>-->
                    <!--<div> 座位数:{{bus.limit}} </div>-->
                    <!--<div> 司机电话:{{bus.phone}} </div>-->
                </van-cell>
            </van-cell-group>
            <div v-else class="sub-title" style="color: #999; text-align: center">等待更新</div>



            <van-divider>房间信息</van-divider>
            <van-cell-group v-if="pageData.room_list">
                <van-cell v-for="(room,index) in pageData.room_list" :title="(index+1)+'.'+room.name" >
                    <div v-for="user in room.member">{{user.name}}({{user.type|userType}})</div>
                </van-cell>
            </van-cell-group>
            <div v-else class="sub-title">用户信息未提交</div>

        </div>


        <div style="padding: 20px;">
            <van-button type="primary"  size="large" v-if="pageData.confirm_3==2" @click.stop="save">信息无误 我已确认</van-button>
            <van-button   type="primary" size="large"  plain v-else >信息已确认</van-button>
            <van-button size="large" plain style="margin: 10px 0" @click.stop="edit">信息需要修改</van-button>
            <van-button size="large" plain style="margin: 10px 0" @click.stop="goIndex">返回首页</van-button>
        </div>
    </div>
</template>

<style scoped="">
</style>
<script>
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog
    } from 'vant';
    export default {
        name: 'saiConfirmDetai3',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'room_list' :[],
                },
                formData:{
                    'id' : this.$route.query.id,
                },
                showTime:false,
                timeField:'',
                showStation:false,
                stationField:'',
            }
        },
        mounted: function () {
            let that = this;
            document.title = "食宿信息确认";
            this.$api.get('/api/sai/confirmshisudetail', {
                'id':that.pageData.id
            }, r => {
                this.pageData = r.data;
            });

        },
        methods: {
            goIndex:function () {
                this.$router.push({
                    'name' :'saiConfirmManage',
                    'query':{}
                })
            },
            save:function () {
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '您确定信息准确无误吗?提交后不得修改!'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/sai/confirmshisuaction', this.formData, r => {
                        that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
                    },r=>{
                        that.$toast.fail(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });
            },
            edit:function () {
                let that = this;
                this.$router.push({
                    'name' :'saiConfirmQr2',
                    'query':{'id':that.pageData.id}
                })
            }
        },
        filters:{
            sex:function(value){
                if(value==1){
                    return '男';
                }
                if(value==2){
                    return '女';
                }
                return '男';
            },
            userType:function(value){
                if(value==1){
                    return '领队';
                }
                if(value==2){
                    return '运动员';
                }
                if(value==3){
                    return '教练员';
                }
                if(value==4){
                    return '裁判员';
                }
                if(value==5){
                    return '家长';
                }
                return '家长';
            }
        },
    }
</script>



// WEBPACK FOOTER //
// saiConfirmDetail3.vue?213d3cd3